<template>
    <div>
    <q-header elevated class="q-py-md q-px-md bg-secondary text-black">
      <q-toolbar>
        <q-toolbar-title> 
          <q-img class="q-ma-sm" src="konsel.png" style="height: auto; max-width: 35px" />
          <span class="text-weight-bold text-uppercase" style="font-size:25px;">
            E-RIDA
          </span>
        </q-toolbar-title> 

        <div v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl"> 
          <q-tabs v-model="tab" inline-label class="text-black "  >
            <q-route-tab class="text-black " style="font-weight: 800" name="Beranda" label="Beranda" to="/" /> 
            <q-btn-dropdown class="text-black " auto-close stretch flat label="Laris">
              <q-list>
                <q-item clickable v-close-popup>
                  <q-item-section>
                    <a style="text-decoration:none; color: inherit;" href="http://admin-rida.konaweselatankab.go.id/">
                    <q-item-label >Izin Penelitian</q-item-label>
                    </a>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/krenova">
                  <q-item-section>
                    <q-item-label >Kreatifitas Inovasi</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/tema">
                  <q-item-section>
                    <q-item-label >Usulan Tema Penelitian</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup>
                  <q-item-section>
                    <a style="text-decoration:none; color: inherit;" href="https://indeks.inovasi.litbang.kemendagri.go.id/">
                    <q-item-label >Indeks Inovasi Daerah</q-item-label>
                    </a>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/ikm">
                  <q-item-section>
                    <q-item-label >Indeks Kepuasan Masyarakat</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup>
                  <q-item-section>
                    <a style="text-decoration:none; color: inherit;" href="http://ipkd-bpp.kemendagri.go.id/">
                    <q-item-label >Indeks Pengelolaan Keuangan Daerah</q-item-label>
                    </a>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup>
                  <q-item-section>
                    <a style="text-decoration:none; color: inherit;" href="https://www.dgip.go.id/">
                    <q-item-label >Hak Kekayaan Intelktual</q-item-label>
                    </a>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup>
                  <q-item-section>
                    <a style="text-decoration:none; color: inherit;" href="https://indeks-inovasi.brin.go.id/">
                    <q-item-label >Indeks Daya Saing Daerah</q-item-label>
                    </a>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            <!-- <q-route-tab class="text-black " name="Artikel Ilmiah" label="Artikel Ilmiah" to="/artikel" />  -->
            <q-btn-dropdown class="text-black " auto-close stretch flat label="Manis">
              <q-list>
                <q-item clickable v-close-popup to="/data_riset">
                  <q-item-section>
                    <q-item-label >Data Riset</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_krenova">
                  <q-item-section>
                    <q-item-label>Data Krenova</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_aksi">
                  <q-item-section>
                    <q-item-label>Data Aksi Perubahan</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_teknologi">
                  <q-item-section>
                    <q-item-label>Data Teknologi Tepat Guna</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_penelitian">
                  <q-item-section>
                    <q-item-label>Data Izin Penelitian</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_iid">
                  <q-item-section>
                    <q-item-label>Data IID</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_ipkd">
                  <q-item-section>
                    <q-item-label>Data IPKD</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_idsd">
                  <q-item-section>
                    <q-item-label>Data IDSD</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_haki">
                  <q-item-section>
                    <q-item-label>Data HaKI</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/data_ikm">
                  <q-item-section>
                    <q-item-label>Data IKM</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/data_tema">
                  <q-item-section>
                    <q-item-label>Data Usulan Penelitian</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            <q-route-tab class="text-black " name="Berita" style="font-weight: bold" label="Rida News" to="/berita" />
            <!-- <q-route-tab class="text-black " name="Inovasi & Teknologi" label="Inovasi & Teknologi" to="/inotek" /> 
            <q-route-tab class="text-black " name="Publikasi" label="Publikasi" to="/publikasi" />  -->
            <q-btn-dropdown class="text-black " auto-close stretch flat label="Kegiatan Rida">
              <q-list>
                <q-item clickable v-close-popup to="/foto">
                  <q-item-section>
                    <q-item-label>Foto</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/video">
                  <q-item-section>
                    <q-item-label>Video</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            <q-btn-dropdown class="text-black " auto-close stretch flat label="Unduhan">
              <q-list>
                <q-item clickable v-close-popup to="/dokumen">
                  <q-item-section>
                    <q-item-label>Dokumen</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
            
            <q-route-tab class="text-black " name="Tentang" style="font-weight: bold" label="Tentang" to="/tentang" />
            
            <!-- <q-route-tab class="text-black " name="Beranda" label="Beranda" to="/" />  -->
          </q-tabs>          
        </div>
        

        <q-btn v-if="$q.screen.lt.sm" dense flat round icon="menu" @click="rightDrawerOpen = !rightDrawerOpen"  />
      </q-toolbar>
    </q-header>

    <q-drawer v-model="rightDrawerOpen" side="right" overlay behavior="mobile" elevated>
        <q-scroll-area class="fit"> 
          
              <q-list>
                <q-item to="/" clickable >
                  <q-item-section>Beranda</q-item-section>
                </q-item>
                <q-expansion-item>
                  <template v-slot:header>
                    <q-item-section>Laris</q-item-section>
                  </template>
                  <q-list> 
                    <q-item clickable>
                      <a style="text-decoration:none; color: inherit;" href="http://admin-rida.konaweselatankab.go.id/">
                      <q-item-section >Izin Penelitian</q-item-section>
                      </a>
                    </q-item>
                    <q-item clickable to="/krenova">
                      <q-item-section >Kreatifitas Inovasi</q-item-section>
                    </q-item>
                    <q-item clickable to="/tema">
                      <q-item-section >Usulan Tema Penelitian</q-item-section>
                    </q-item>
                    <q-item clickable>
                      <a style="text-decoration:none; color: inherit;" href="https://indeks.inovasi.litbang.kemendagri.go.id/">
                      <q-item-section >Indeks Inovasi Daerah</q-item-section>
                      </a>
                    </q-item>
                    <q-item clickable to="/ikm">
                      <q-item-section >Indeks Kepuasan Masyarakat</q-item-section>
                    </q-item>
                    <q-item clickable>
                      <a style="text-decoration:none; color: inherit;" href="http://ipkd-bpp.kemendagri.go.id/">
                      <q-item-section >Indeks Pengelolaan Keuangan Daerah</q-item-section>
                      </a>
                    </q-item>
                    <q-item clickable>
                      <a style="text-decoration:none; color: inherit;" href="https://www.dgip.go.id/">
                      <q-item-section >Hak Kekayaan Intelektual</q-item-section>
                      </a>
                    </q-item>
                    <q-item clickable>
                      <a style="text-decoration:none; color: inherit;" href="https://indeks-inovasi.brin.go.id/">
                      <q-item-section >Indeks Daya Saing Daerah</q-item-section>
                      </a>
                    </q-item>
                  </q-list>
                </q-expansion-item>
                <q-expansion-item>
                  <template v-slot:header>
                    <q-item-section>Manis</q-item-section>
                  </template>
                  <q-list> 
                <q-item clickable v-close-popup to="/data_riset">
                  <q-item-section>
                    <q-item-label >Data Riset</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_krenova">
                  <q-item-section>
                    <q-item-label>Data Krenova</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_aksi">
                  <q-item-section>
                    <q-item-label>Data Aksi Perubahan</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_teknologi">
                  <q-item-section>
                    <q-item-label>Data Teknologi Tepat Guna</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_penelitian">
                  <q-item-section>
                    <q-item-label>Data Izin Penelitian</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_iid">
                  <q-item-section>
                    <q-item-label>Data IID</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_ipkd">
                  <q-item-section>
                    <q-item-label>Data IPKD</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_idsd">
                  <q-item-section>
                    <q-item-label>Data IDSD</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/data_haki">
                  <q-item-section>
                    <q-item-label>Data HaKI</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/data_ikm">
                  <q-item-section>
                    <q-item-label>Data IKM</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/data_tema">
                  <q-item-section>
                    <q-item-label>Data Usulan Penelitian</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
              </q-expansion-item>
                <q-item to="/berita" clickable >
                  <q-item-section>Rida News</q-item-section>
                </q-item>
                <q-expansion-item>
                  <template v-slot:header>
                    <q-item-section>Kegiatan Rida</q-item-section>
                  </template>
                  <q-list> 
                <q-item clickable v-close-popup to="/foto">
                  <q-item-section>
                    <q-item-label >Foto</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/video">
                  <q-item-section>
                    <q-item-label>Video</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
              </q-expansion-item>
                <q-expansion-item>
                  <template v-slot:header>
                    <q-item-section>Unduhan</q-item-section>
                  </template>
                  <q-list> 
                <q-item clickable v-close-popup to="/foto">
                  <q-item-section>
                    <q-item-label >Dokumen</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
              </q-expansion-item>
                <q-item to="/tentang" clickable >
                  <q-item-section>Tentang</q-item-section>
                </q-item>
              </q-list>    

 
        </q-scroll-area>      
    </q-drawer>        
    </div>
</template>

<script>
 
export default {
    name: "headernya",
    
//   setup () {
//     const rightDrawerOpen = ref(false)

//     return {
//       rightDrawerOpen,
//       toggleRightDrawer () {
//         rightDrawerOpen.value = !rightDrawerOpen.value
//       }
//     }
//   },

  data() {
    return {
      rightDrawerOpen:false,
      tab:'Beranda',
      link :'inbox',
    }
  },
  methods: {
 
  },
}
</script>